import {IDS} from '../../audit-action-id.constants';
import {TYPES} from '../../audit-action-type.constants';
import {TYPES as ACC_TYPES} from '../../../accreditation-action-type.constants';
import * as AccActions from '../../../accreditation.actions';
import * as DetailsActions from './details.actions';
import * as AuditActions from '../../audit.actions';
import {TAB_SELECT} from '../../../../../common/tabs/tabs.constants';
import {formatDate} from '../../../../../common/utils/util.date';
import {DATE_FORMAT} from '../../../../../common/utils/util.constants';
import pick from 'lodash/pick';
import {IDS as SECTION_IDS} from "../../../requirements-assessment/requirements-assessment-action-id.constants";

class AuditDetailsController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $filter,
                $timeout,
                Notifier,
                DocumentManager,
                EmployeeService) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.identifier = IDS.accAudit;
        this.selectedFormat = null;
        this.MAX_AUDITORS = 4;

        this.exportFormat = [
            {format: 'pdf',     name: 'PDF'},
            {format: 'csv',     name: 'CSV'},
            {format: 'xls',     name: 'Excel 5'},
            {format: 'xlsx',    name: 'Excel 2007'}
        ]
    }

    $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        this.unsubscribe = this.$ngRedux.connect(state => {
            const { schedule, details } = state.accreditation.accAudit;
            const {locationName, fiscalYearStart, type_code} = state.accreditation.accAudit.siteLocation;
            const headOfficeDetails = state.accreditation.accAudit.headOfficeDetails;
            const {siteLocation, headOffice, year} = state.accreditation.accDashboardLocationYear;

            return {
                requirementId:          details.sectionId,
                sectionName:            details.sectionName,
                requirementLevel:       details.sectionLevel,
                siteLocationName:       locationName,
                siteLocation:           siteLocation,
                headOfficeName:         headOfficeDetails?.name,
                headOffice:             headOffice || headOfficeDetails?.uuid,
                isSiteLocation:         type_code === 'slo',
                fiscalYearStart,
                fiscalYear: year,


                //review
                name:                   details.name,
                description:            details.description,
                date:                   details.date,
                auditors:               details.auditors,
                auditId:                details.auditId,
                sourceTab:              details.sourceTab,
                // selectedEvidenceProvider: details.selectedEvidenceProvider,
                selectedAuditor:        details.selectedAuditor,

                //external evidence provider
                // evidenceProviderFirstName:  details.evidenceProviderFirstName,
                // evidenceProviderLastName:   details.evidenceProviderLastName,
                // evidenceProviderEmail:      details.evidenceProviderEmail,

                //external quality manager
                // qualityManagerFirstName:    details.qualityManagerFirstName,
                // qualityManagerLastName:     details.qualityManagerLastName,
                // qualityManagerEmail:        details.qualityManagerEmail,
                // activities:                 details.activities,
            }
        }, {
            ...AccActions,
            ...AuditActions,
            ...DetailsActions,
        })(this);

        this.schemeCode = this.$stateParams.itemCode;

        this.updateAutocompleteLabel();
        /* Reset stateParams for case when user goes back by clicking tab "Audit Schedule"
            So that there will be no stateParams when executing TabsController.selectTab() */
        const ctrl = this;
        // this.$timeout(() =>{
        //     ctrl.$ngRedux.dispatch({
        //         type: 'TAB_PARAMS',
        //         id: IDS.app_accreditation_scheme_audit_schedule,
        //         initParams: false,
        //         stateParams:{
        //             hof: undefined,
        //             slo: undefined,
        //             year: undefined,
        //             section: undefined,
        //         },
        //     });
        // }, 200);
    }

    onAddAuditorButton(){
        if(this.auditors.length >= this.MAX_AUDITORS){
            this.Notifier.error('COMMON.CLIENT_RESPONSE.UNABLE_TO_ADD_MORE_ITEMS');
            return;
        }
        if(this.auditors.some(item => item.sub_uuid === this.selectedAuditor.sub_uuid)) {
            this.Notifier.error('COMMON.CLIENT_RESPONSE.ITEM_PRESENT_ALREADY');
            return;
        }

        if(this.selectedAuditor) {
            this.addAuditor({
                emp_uuid:       this.selectedAuditor.sub_uuid,
                first_name:     this.selectedAuditor.first_name,
                last_name:      this.selectedAuditor.last_name,
                email:          this.selectedAuditor.email,
                assignee:    `${this.selectedAuditor.first_name} ${this.selectedAuditor.last_name}`,
                username:       this.selectedAuditor.username,
                type_name:      this.selectedAuditor.subject_type_name,
            });

        }
    }

    onRemoveEvidenceProvider(item) {
        this.$ngRedux.dispatch({
            type: TYPES.REMOVE_AUDIT_ASSIGNEE,
            id: this.identifier,
            path: 'details.evidenceProviders',
            item
        });
    }

    onRemoveReviewer(item) {
        this.$ngRedux.dispatch({
            type: TYPES.REMOVE_AUDIT_ASSIGNEE,
            id: this.identifier,
            path: 'details.auditors',
            item
        });
    }
    onGoToRequirement() {
        let newState;
        switch(this.requirementLevel) {
            case 2: newState = SECTION_IDS.app_accreditation_scheme_requirements_assessment_dashboard; break;
            case 3: newState = SECTION_IDS.app_accreditation_scheme_requirements_assessment_evidence_groups; break;
        }

        const ctrl = this;
        this.fetchFrameworkRequirementsTreeProgress(this.schemeCode, this.siteLocation, this.fiscalYear).then(() => {
            ctrl.selectRequirementById(ctrl.requirementId);
                ctrl.$state.go(newState, {
                    itemCode:   ctrl.schemeCode,
                    requirement:ctrl.requirementId,
                    year:       ctrl.fiscalYear,
                    hof:        ctrl.headOffice,
                    slo:        ctrl.siteLocation,
                });
        });
    }

    // async onEvidenceProviderAutocompleteKeywordQuery (keyword) {
    //     if(this.isQManagersSwitchOn) {
    //         return keyword ?
    //             this.auditors.filter(this.getFilter(keyword))
    //             : this.auditors
    //     }
    //     else
    //         return await this.fetchEvidenceProviderCandidates(keyword, this.siteLocation || this.headOffice);
    // }

    getFilter(keyword) {
        return item => {
            return `${item.first_name} ${item.last_name} ${item.username}`.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
        }
    }

    updateAutocompleteLabel() {
        const key = this.isQManagersSwitchOn ? 'QUALITY_MANAGERS' : 'EMPLOYEES';
        const addReviewer = this.$filter('translate')('ACCREDITATION.AUDIT.DETAILS.ADD_REVIEWER');
        const searchFrom = this.$filter('translate')(`ACCREDITATION.AUDIT.DETAILS.SEARCH_FROM_${key}`);
        this.autocompleteLabel = `${addReviewer} (${searchFrom})`;
    }

    onSubmit() {
        if(this.auditors.length === 0) {
            this.Notifier.error('ACCREDITATION.AUDIT.DETAILS.NO_AUDITOR_SELECTED');
            return;
        }

        if(this.detailsForm.$invalid) {
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            return;
        }

        this.updateRequirementAudit(
            this.auditId,
            formatDate(this.date, DATE_FORMAT.OUTPUT),
            this.auditors.map(item => item.emp_uuid)
        ).then( () => {
            this.fetchAudits(this.schemeCode, this.siteLocation, this.fiscalYear, this.fiscalYearStart).then(()=>{
                const test = this.$stateParams;
                this.$ngRedux.dispatch({
                    type: TAB_SELECT,
                    id: IDS.app_accreditation_scheme_audit_schedule,
                    state: IDS.app_accreditation_scheme_audit_schedule_table,
                })
            });
        });
    }
    $onDestroy() {
        this.unsubscribe();
    }
}

AuditDetailsController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$filter',
    '$timeout',
    'Notifier',
    'DocumentManager',
    'EmployeeService']

export const accAuditDetails = {
    controller: AuditDetailsController,
    template: require('./details.html')
}
